module.exports = __webpack_public_path__ + "static/media/museum.2cddb829.png";